import React from 'react';

const ModalOrderDetailMobile = ({ isOpen, onClose, orderData }) => {
  if (!isOpen) return null;

  const rawText = orderData?.maps_url || 'No hay detalles disponibles para este pedido.';

  const fallbackCopyTextToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    
    // Evitar que la pantalla haga scroll al final
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      if (successful) {
        alert('Información copiada al portapapeles');
      } else {
        alert('No se pudo copiar automáticamente. Por favor, selecciona y copia el texto manualmente.');
      }
    } catch (err) {
      console.error('Error en fallback de copiado:', err);
      alert('Error al copiar la información');
    }

    document.body.removeChild(textArea);
  };

  const copyToClipboard = () => {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(rawText);
      return;
    }
    
    navigator.clipboard.writeText(rawText).then(() => {
      alert('Información copiada al portapapeles');
    }).catch(err => {
      console.error('Error al usar clipboard API: ', err);
      fallbackCopyTextToClipboard(rawText);
    });
  };

  const formatWhatsAppText = (text) => {
    if (!text) return null;
    const parts = text.split(/(\*[^*]+\*)/g);
    return parts.map((part, index) => {
      if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
        return <strong key={index} className="font-bold text-gray-900">{part.slice(1, -1)}</strong>;
      }
      return <span key={index}>{part}</span>;
    });
  };

  return (
    <div className="fixed inset-0 bg-gray-50 z-50 flex flex-col h-[100dvh] w-full overflow-hidden">
      {/* Mobile Header */}
      <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-white shadow-sm">
        <h2 className="text-xl font-bold text-gray-900">
          Detalle de Venta
        </h2>
        <button
          onClick={onClose}
          className="text-gray-500 hover:text-gray-800 p-2"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-4 bg-gray-50">
        {orderData ? (
          <div className="bg-white p-5 md:p-8 rounded-xl border border-gray-200 shadow-sm">
            <div className="font-sans text-gray-800 text-base md:text-lg leading-relaxed whitespace-pre-wrap">
              {formatWhatsAppText(rawText)}
            </div>
          </div>
        ) : null}
      </div>

      {/* Footer Actions */}
      <div className="p-4 border-t border-gray-200 bg-white shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)]">
        <button
          onClick={copyToClipboard}
          className="w-full flex justify-center items-center py-3 md:py-4 bg-green-500 hover:bg-green-600 active:bg-green-700 text-white font-bold text-lg rounded-xl shadow-sm transition-colors"
        >
          <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
          </svg>
          Copiar para WhatsApp
        </button>
      </div>
    </div>
  );
};

export default ModalOrderDetailMobile;
